<template>
  <v-row class="inner-content">
    <v-col>

      <v-card class="pt-2">
        <v-card-text>
          <p>Use this feature to import keyword relocation records from the Analyics labeling data in the DWH and pre-process it, then use the Review Data tab to check the results.</p>
          <p>If the selected account has unprocessed records, using this feature will run the pre-preprocessing again without importing new records.
            This is useful if you noticed that the Google account has labeling or other set-up errors, you have fixed those errors, and you want to refresh the records shown here.
          </p>
        </v-card-text>
      </v-card>

      <v-card class="pt-2">
        <v-card-title>
          <span>Account</span>
          <v-spacer></v-spacer>

          <GoogleAccountAutoComplete
            v-model="selectedAccountID"
            @changed="accountChanged"
          ></GoogleAccountAutoComplete>

          <v-spacer></v-spacer>

          <v-btn color="warning" :loading="updating" @click="update">Update from DWH</v-btn>
          <v-spacer></v-spacer>

        </v-card-title>

        <SystemJobsTable :headers="jobHeaders" :jobType="jobType" :updateKey="updateTableKey"></SystemJobsTable>
      </v-card>

    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'KeywordRelocationRefreshData',

  data () {
    return {
      lsSelectedAccount: 'keywordRelocation_selectedAccount',
      selectedAccountID: 0,
      updating: false,
      updateTableKey: 'init',
      jobType: 'Core - Keyword Relocation Data Preparation',
      jobHeaders: [
        { text: 'User', value: 'user_name' },
        { text: 'Account', value: 'text1' },
        { text: 'Status', value: 'status' },
        { text: 'Entry at', value: 'entry_at_time' },
        { text: 'Completed at', value: 'completed_at_time' },
        { text: 'External message', value: 'external_message' },
      ],
    }
  },

  computed: {
    refreshDBEndpoint () {
      return '/a/google/accounts/' + this.selectedAccountID + '/prepare-keyword-relocation-data'
    },
  },

  components: {
    GoogleAccountAutoComplete: () => import('@/components/autocompletes/GoogleAccountAutoComplete.vue'),
    SystemJobsTable: () => import('@/components/tables/SystemJobsTable.vue')
  },

  methods: {
    accountChanged: function () {
      if (!this.selectedAccountID) {
        return
      }

      // save to local storage
      localStorage.setItem(this.lsSelectedAccount, JSON.stringify(this.selectedAccountID))
    },

    update: function () {
      if (!this.selectedAccountID) {
        return
      }
      this.updating = true

      var updateObJ = {
        'accountID': this.accountID
      }
      var body = JSON.stringify(updateObJ)

      this.$http.post(this.refreshDBEndpoint, body).then(resp => {
        this.updateTableKey = this.$dateTime.now().toString()
      })
      .catch(errResp => {
        this.$store.commit('system/setAPIError', { method: 'POST', url: this.refreshDBEndpoint, description: errResp.response.data.err_description, ext_msg: errResp.response.data.external_message })
      })
      .finally(() => this.updating = false)
    },
  },

  created: function () {

    // if present, use local selected account
    if (localStorage.getItem(this.lsSelectedAccount)) {
      this.selectedAccountID = JSON.parse(localStorage.getItem(this.lsSelectedAccount))
    }
  },
}
</script>
